import { Form } from 'react-bootstrap';
import Button from '../../components/Button/Button';
import Loader from '../../components/Loader/Loader';
import Input from '../../components/Input/Input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinus } from '@fortawesome/free-solid-svg-icons';
import React from 'react';

const StakeholderRequestType = ({ name, subTypes, loader, addRowHandler, removeRowHandler, onSubmit, onChange, onSubTypeChangeHandler }) => {
  return (
    <Form onSubmit={onSubmit}>
      {loader && <div className="loader"><Loader /></div>}
      <div className="row">
        <div className="col-md-12">
          <Input
            label="Name"
            type="text"
            name="name"
            value={name}
            onChangeHandler={onChange}
            placeholder="Enter subject name"
            required={true}
          />
        </div>
        <Form.Label>Available for Request SubTypes</Form.Label>
        {subTypes &&
          subTypes.map((subType, idx) => (
            <React.Fragment key={idx}>
              <div className="col-md-7 mt-2">
                <Input
                  id={subType.id}
                  name={`name_${idx}`}
                  value={subType.name}
                  placeholder="Enter request sub type"
                  onChangeHandler={onSubTypeChangeHandler}
                />

              </div>
              <div className="col-md-3 mt-2">
                {idx === 0 ? (
                  <Button
                    variant="primary"
                    onClick={addRowHandler}
                    type="button"
                    className="text-center"
                  >
                    <FontAwesomeIcon icon={faPlusCircle} /></Button>
                ) : (
                  <Button
                    type="submit"
                    variant="danger"
                    onClick={() => removeRowHandler(subType)}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </Button>
                )}
              </div>
            </React.Fragment>
          ))}
        <div className="col-md-12 justify-content-end d-flex" style={{ marginLeft: "inherit" }}>
          <div className="mt-2">
            <Button
              variant="success"
              disabled={loader}
              type="submit">
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};

export default StakeholderRequestType;
